/**
 * Matrix for mapping between SQL Types (Backend) and UI Types (Frontend)
 * matchers: used for SQL -> UI conversion (mapSqlTypeToUiType)
 * sqlType: used for UI -> SQL conversion (mapUiTypeToSqlType) as the default type
 */
const DATA_TYPE_MATRIX = [
  {
    uiValue: 'String',
    sqlType: 'VARCHAR',
    matchers: ['VARCHAR', 'CHAR', 'STRING', 'CLOB']
  },
  {
    uiValue: 'Number',
    sqlType: 'INTEGER',
    matchers: ['INT', 'INTEGER', 'NUMERIC', 'SMALLINT', 'BIGINT', 'TINYINT', 'NUMBER']
  },
  {
    uiValue: 'Double',
    sqlType: 'DOUBLE',
    matchers: ['DOUBLE', 'FLOAT', 'DECIMAL', 'REAL'] // NUMBER often implies floating point in some DBs, or general number
  },
  {
    uiValue: 'Boolean',
    sqlType: 'BOOLEAN',
    matchers: ['BOOL', 'BIT', 'BOOLEAN']
  },
  {
    uiValue: 'DateTime',
    sqlType: 'DATETIME',
    matchers: ['DATETIME', 'TIMESTAMP']
  },
  {
    uiValue: 'Date',
    sqlType: 'DATE',
    matchers: ['DATE']
  },
  {
    uiValue: 'Text',
    sqlType: 'TEXT',
    matchers: ['TEXT']
  },
  {
    uiValue: 'Currency',
    sqlType: 'DECIMAL', // Currency is typically DECIMAL
    matchers: ['MONEY', 'CURRENCY']
  },
  // Fallbacks or specialized types
  {
    uiValue: 'Dropdown',
    sqlType: 'VARCHAR', // Dropdowns usually store strings (codes)
    matchers: []
  },
  {
    uiValue: 'Checkbox',
    sqlType: 'BOOLEAN',
    matchers: []
  },
  {
    uiValue: 'Auto-number',
    sqlType: 'INTEGER', // Auto number is int
    matchers: []
  },
  {
    uiValue: 'Email',
    sqlType: 'VARCHAR',
    matchers: []
  },
  {
    uiValue: 'URL',
    sqlType: 'VARCHAR',
    matchers: []
  }
];

/**
 * Maps SQL types from backend to UI compatible types
 * uses DATA_TYPE_MATRIX for lookup
 * Returns fallback 'String' if no match found
 */
export function mapSqlTypeToUiType(sqlType: string): string {
  if (!sqlType) return 'String';

  const normalizedSqlType = sqlType.toUpperCase();

  const match = DATA_TYPE_MATRIX.find(
    (m: any) =>
      m.sqlType === normalizedSqlType || m.matchers.some((matcher: any) => normalizedSqlType.includes(matcher))
  );

  return match ? match.uiValue : 'String';
}
